import { ServiceNames } from "@models/service_enums";
import { Injectable } from "@angular/core";
import { LeveragedTokenWallet } from "@models/asset/cryptocoins/wallets/leveraged_token_wallet";
import { LEVERAGED_TOKEN_TRANSACTIONS_ROOM, LEVERAGED_TOKEN_WALLETS_ROOM } from "@helpers/constants";
import { DestructorService } from "@core-services/destructor.service";
import { InitService } from "@core-services/init.service";
import { GetPendingTradesGQLService } from "@gql/offer";
import { AssetWalletService } from "@main-services/wallet/asset_wallet.service";
import { LeveragedToken } from "@models/asset/cryptocoins/currencies/leveraged_tokens";
import { parseList } from "@helpers/functions";
import { LeveragedTokenTransaction } from "@models/transaction/leveraged_token_transaction";
import { SocketService } from "@main-services/socket.service";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { InfoService } from "@core-services/info.service";
import { TranslationService } from "@core-services/translation.service";
import { CryptoTransactionNotifyService } from "@main-services/notify/crypto_transaction.notify.service";
import { WalletsBalancesFacadeService } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.facade.service";
import { LeveragedTokenService } from "@main-services/currency/leveragedToken.service";
import { Observable, of } from "rxjs";

const name = ServiceNames.LEVERAGED_TOKEN_WALLET;

@Injectable({
	providedIn: "root"
})
export class LeveragedTokenWalletService extends AssetWalletService<
	LeveragedTokenWallet,
	LeveragedTokenTransaction,
	LeveragedToken
> {
	public name: string = ServiceNames.LEVERAGED_TOKEN_WALLET;

	public TxType = LeveragedTokenTransaction;
	public WalletType = LeveragedTokenWallet;

	protected transactionSocketRoomName: string = LEVERAGED_TOKEN_TRANSACTIONS_ROOM;
	protected walletSocketRoomName: string = LEVERAGED_TOKEN_WALLETS_ROOM;

	public constructor(
		protected currencyService: LeveragedTokenService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected initService: InitService,
		protected transactionNotifyService: CryptoTransactionNotifyService,
		protected destructor: DestructorService,
		protected getPendingTradesGQLService: GetPendingTradesGQLService,
		protected walletBalanceFacade: WalletsBalancesFacadeService
	) {
		super(initService, destructor, name, getPendingTradesGQLService);
	}

	public getParseData(wallets): LeveragedTokenWallet[] {
		const lTokRawWallets = wallets?.["attributes"]["cryptocoin"]["leveraged_tokens"];

		if (!lTokRawWallets) {
			return [];
		}

		return parseList(lTokRawWallets["attributes"]["wallets"], LeveragedTokenWallet);
	}

	public async cancel(t: LeveragedTokenTransaction): Promise<LeveragedTokenTransaction> {
		const oldTransaction = new LeveragedTokenTransaction();
		Object.assign(oldTransaction, t);
		const call = this.apicallService.deleteRequest(
			"wallet/" + t.getWalletId() + "/transaction/" + t.getId(),
			new ApicallOption(LeveragedTokenTransaction)
		);
		return super.cancelSub(call, t, oldTransaction).toPromise();
	}

	public hasWallets$(): Observable<boolean> {
		const hasLtokenWallets = this.list.some((wallet) => wallet.isDefault() && !wallet.isNew());
		return of(hasLtokenWallets);
	}
}
